export default {
    chatRoom: '聊天室',
    theme_light: '切换浅色主题',
    theme_dark: '切换深色主题',
    fullscreen: '全屏',
    exitFullscreen: '退出全屏',
    top: '回到顶部'
}
